export default __webpack_public_path__ + "static/media/tela-milersoft-cloud-nas-nuvens-1366x768.f8c3209e.png";